import { Tipo_condominio } from './../../../models/tipo_condominio.model';
import { Component } from "@angular/core";

@Component({
    selector: "page-tipo_condominio",
    templateUrl: "./tipo_condominio.component.html",
    styleUrls: ["./tipo_condominio.component.css"]
    
})


export class Tipo_condominioComponent {
    public rows = [];
    public actualRow;
    public tipo_condominio: Tipo_condominio;
    public form;
    public n_form;
    public  condominio = {"A": false, "B": false}
    constructor(){
        if(!JSON.parse(localStorage.getItem("tipo_condominio"))){
            localStorage.setItem("tipo_condominio", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("tipo_condominio"));
            this.condominio = { 
             "A": this.rows[0] ? this.rows[0].condominio["A"] : false,
             "B": this.rows[0]? this.rows[0].condominio["B"] : false,
             
         

            }
        }

    }

    ngOnInit(){
        this.n_form = localStorage.getItem("form")
        console.log("Formulario", this.n_form)
    }

    add_tipo_condominio(){
        localStorage.setItem("tipo_condominio",JSON.stringify([]));
        this.actualRow = localStorage.getItem("tipo_condominio");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            condominio: this.condominio
            
          
        })
        localStorage.setItem("tipo_condominio", JSON.stringify(this.rows));
    }
  
    delete_tipo_condominio(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("tipo_condominio", JSON.stringify(this.rows));
            }
        }
    }   
}